angular
    .module('app')
    .component('login', {
        templateUrl: '/templates/pages/login/login.html',
        controller: 'LoginController',
        controllerAs: 'vm',
    });